export default __webpack_public_path__ + "static/media/checkbox-circle-line.2a16c3f5.svg";